const React = require("react");
const createReactClass = require("create-react-class");
const {ErrorIcon} = require("../../core/view/ErrorIcon");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const MessageCopy = require("../data/CopyTable").getUnsupportedBrowserCopy();

const styles = require("./styles/BrowserModal.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "BrowserModal",

		// Used by vault update HOC
		vaultEvents: {
			showBrowserWarning: function() {
				this.setState({isOpen: true});
			},
		},

		getInitialState: function() {
			return {
				isOpen: false,
			};
		},

		onClose: function() {
			this.setState({isOpen: false});
		},

		render: function() {
			if (this.state.isOpen) {
				return (
					<div className={styles.mainContainer} onClick={this.onClose}>
						<div className={styles.main} onClick={evt => evt.stopPropagation()}>
							<ErrorIcon className={styles.icon} />
							<div className={styles.message}>{MessageCopy}</div>
							<div className={styles.buttonContainer}>
								<div className={styles.button} onClick={this.onClose}>
									Continue with your current browser.
								</div>
							</div>
						</div>
					</div>
				);
			} else {
				return null;
			}
		},
	})
);
